import { IconBase, IconBaseProps } from 'react-icons';

import { IconManifest } from 'app/agriculture/icons/types';

export const shedIcon: IconManifest = {
    id: 'shed-icon',
    width: 128,
    height: 128,
    d: 'M63.2381 18.0965C62.9079 18.1321 52.6629 22.5917 40.4622 28.0063C16.2844 38.7441 17.2394 38.2667 16.3962 40.0698L16 40.9181V105.594L16.4013 106.442C16.9092 107.503 17.8641 108.428 18.9613 108.916C20.1397 109.434 21.9378 109.423 23.0451 108.885C24.0711 108.387 25.0768 107.377 25.539 106.381L25.9048 105.594L25.9454 75.5187L25.9911 45.4387L44.5714 37.1797C50.9055 34.3558 57.2463 31.5469 63.5936 28.753C63.9848 28.6057 66.2603 29.5708 83.0222 37.0222L102.009 45.459V105.426L102.491 106.442C103.375 108.306 104.919 109.271 107.032 109.271C109.15 109.271 110.684 108.26 111.604 106.259L112 105.385L111.959 73.0654L111.914 40.7454L111.456 39.8768C111.154 39.3371 110.77 38.8472 110.319 38.4241C109.445 37.6825 66.1689 18.4063 64.7771 18.1473C64.4708 18.0783 64.1603 18.0291 63.8476 18C63.6469 18.0461 63.4432 18.0784 63.2381 18.0965Z',
};

export function ShedIcon(props: IconBaseProps) {
    const { id, d } = shedIcon;

    return (
        <IconBase id={id} {...props} viewBox="16 16 96 96" data-testid="ShedIcon">
            <path d={d} fill="currentColor" />
        </IconBase>
    );
}
